import { render } from "./GTComponentSelect.vue?vue&type=template&id=584eef7e&scoped=true"
import script from "./GTComponentSelect.vue?vue&type=script&lang=js"
export * from "./GTComponentSelect.vue?vue&type=script&lang=js"

import "./GTComponentSelect.vue?vue&type=style&index=0&id=584eef7e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-584eef7e"

export default script